declare namespace $ {

	export class $mol_icon_loop extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=loop.view.tree.d.ts.map